<template>
  <div class="main-box">
    <div class="mg-bt-10">
      <el-button type="primary" size="small" icon="el-icon-plus" @click="addMenu()">添加省</el-button>
    </div>
    <el-table
        :data="tableData"
        ref="rfTable"
        border
        row-key="id"
        style="width: 100%;"
        size="mini"
        :load="load"
        lazy
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
      <el-table-column
          prop="title"
          label="城市名称">
      </el-table-column>
      <el-table-column
          prop="id"
          label="区号">
      </el-table-column>
      <el-table-column
          prop="ordering"
          label="排序"
          align="center"
          width="120">
      </el-table-column>
      <el-table-column
          prop="ftime"
          label="添加时间"
          align="center"
          width="140">
      </el-table-column>
      <el-table-column
          fixed="right"
          label="操作"
          align="left"
          width="250">
        <template slot-scope="scope">
          <el-button type="warning" size="mini" @click="editMenu(scope.row)">编辑</el-button>
          <el-popconfirm
              class="mg-lf-10 mg-rt-10"
              title="确认要删除吗？"
              @confirm="delMenu(scope.row)"
          >
            <el-button slot="reference" type="danger" size="mini">删除</el-button>
          </el-popconfirm>
          <el-button type="primary" size="mini" @click="addMenu(scope.row)" v-if="scope.row.type<3">添加子类</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :title="menuTitle" :visible.sync="dialogFormVisible" custom-class="dialog">
      <el-form :model="form" size="small">
        <el-form-item label="名称" :label-width="formLabelWidth">
          <el-input v-model="form.title" autocomplete="off" placeholder="请输入城市名称"></el-input>
        </el-form-item>
        <el-form-item label="区号" :label-width="formLabelWidth">
          <el-input v-model="form.id" autocomplete="off" placeholder="请输入城市区号"></el-input>
        </el-form-item>
        <el-form-item label="序号" :label-width="formLabelWidth">
          <el-input v-model="form.ordering" autocomplete="off" placeholder="请输入城市序号"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="saveMenu" size="small">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

export default {
  components: {
  },
  data() {
    return {
      info: false,
      source_domain: this.config.SOURCE_DOMAIN,
      menuTitle: '添加地区',
      dialogFormVisible: false,
      form: {
        id: 0,
        pid: 0,
        title: '',
        ordering: ''
      },
      formLabelWidth: '80px',
      tableData: []
    };
  },
  created() {
    this.getList();
  },
  mounted() {
  },
  computed: {
  },
  methods: {
    load(tree, treeNode, resolve) {
      this.$api.merchant.cityIndex({pid:tree.id}, res => {
        if(res.errcode == 0) {
          resolve(res.data)
        } else {
          this.fail(res.errmsg)
        }
      })
    },
    getList() {
      var that = this
      that.showLoading()
      this.$api.merchant.cityIndex({}, function (res) {
        that.hideLoading()
        if(res.errcode == 0) {
          that.tableData = res.data
        } else {
          that.fail(res.errmsg)
        }
      })
    },
    editMenu(item) {
      this.form.id = item.id
      this.form.pid = item.pid
      this.form.title = item.title
      this.form.ordering = item.ordering
      this.dialogFormVisible = true
    },
    addMenu(item) {
      if(item) {
        this.form.id = ''
        this.form.pid = item.id
        this.form.title = ''
        this.form.ordering = ''
      } else {
        this.form.id = ''
        this.form.pid = 1
        this.form.title = ''
        this.form.ordering = ''
      }
      this.dialogFormVisible = true
    },
    saveMenu() {
      if(this.info.title=='') {
        this.fail('请填写名称')
        return false
      }
      this.$api.merchant.cityEdit(this.form, res => {
        if(res.errcode == 0) {
          this.dialogFormVisible = false
          this.success(res.errmsg)
          this.getList()
        } else {
          this.fail(res.errmsg)
        }
      })
    },
    delMenu(item) {
      this.$api.merchant.cityDel({id: item.id}, res => {
        if (res.errcode == 0) {
          this.success('删除成功')
          this.getList()
        } else {
          this.fail(res.errmsg)
        }
      })
    }
  }
};
</script>
<style scoped>
</style>
